import { Action } from '@reduxjs/toolkit'

import {
  CLEAR_CURRENT_CHANNEL_CONNECTION,
  CREATE_CHANNEL_CONNECTION_SUCCESS,
  FETCH_CHANNEL_CONNECTIONS_SUCCESS,
  SET_CURRENT_CHANNEL_CONNECTION,
  UPDATE_CHANNEL_CONNECTION_SUCCESS
} from './actionTypes'
import { ChannelConnection } from './interfaces'

interface FetchChannelConnectionsResponse extends Action {
  response: ChannelConnection[]
}

interface ConnectionChannelResponse extends Action {
  response: ChannelConnection
}

interface ConnectionChannel extends Action {
  channelConnection: ChannelConnection
}

type OrganizationChannelConnectionsPageState = {
  channelConnections: ChannelConnection[]
}

const initialState: OrganizationChannelConnectionsPageState = { channelConnections: [] }

export default (state = initialState, action: Action): OrganizationChannelConnectionsPageState => {
  switch (action.type) {
    case FETCH_CHANNEL_CONNECTIONS_SUCCESS: {
      const channelConnections = (action as FetchChannelConnectionsResponse).response
      return {
        ...state,
        channelConnections: channelConnections
          ? channelConnections.map((channelConnection: ChannelConnection) => ({
              ...channelConnection,
              currentChannelConnection: false
            }))
          : []
      }
    }
    case CREATE_CHANNEL_CONNECTION_SUCCESS: {
      const connectionChannelResponse = (action as ConnectionChannelResponse).response
      return {
        ...state,
        channelConnections: [
          ...state.channelConnections,
          { ...connectionChannelResponse, currentChannelConnection: false }
        ]
      }
    }
    case UPDATE_CHANNEL_CONNECTION_SUCCESS: {
      const response = (action as ConnectionChannelResponse).response
      return {
        ...state,
        channelConnections: state.channelConnections.map((channelConnection: ChannelConnection) => {
          if (channelConnection.id !== response.id) {
            return channelConnection
          }
          return {
            ...channelConnection,
            ...response,
            currentChannelConnection: false
          }
        })
      }
    }
    case SET_CURRENT_CHANNEL_CONNECTION: {
      const currentConnectionChannel = (action as ConnectionChannel).channelConnection
      return {
        ...state,
        channelConnections: state.channelConnections.map((channelConnection: ChannelConnection) => {
          if (channelConnection.id !== currentConnectionChannel.id) {
            return { ...channelConnection, currentChannelConnection: false }
          }
          return {
            ...channelConnection,
            currentChannelConnection: true
          }
        })
      }
    }
    case CLEAR_CURRENT_CHANNEL_CONNECTION: {
      return {
        ...state,
        channelConnections: state.channelConnections.map((channelConnection: ChannelConnection) => ({
          ...channelConnection,
          currentChannelConnection: false
        }))
      }
    }
    default: {
      return state
    }
  }
}
